const Carousel = () => {
  return (
    <div className="slide-container">
      <div className="slider">
        <div className="slide-track">
          <div className="slide">
            <img src="./images/carousel/amc-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/warnerbros-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/universal-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/imax-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/sony-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/cinemark-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/lionsgate-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/disney-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/cinemacon-logo.jpg"
              height="100"
              alt=""
            />
          </div>

          <div className="slide">
            <img src="./images/carousel/barco-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/kingdom-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/fathom-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/regal-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/focus-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/harkins-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/a24-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/marcus-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/coke-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/showcase-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/roadside-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/neon-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/paramount-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/reald-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/briarcliff-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/trafalgar-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/vertical-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/bb-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/gkids-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/bleecker-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/mgm-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/cinemaunited-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="./images/carousel/cj4dplex-logo.jpg"
              height="100"
              alt=""
            />
          </div>
          <div className="slide">
            <img src="./images/carousel/dolby-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/mubi-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/screenx-logo.jpg" height="100" alt="" />
          </div>
          <div className="slide">
            <img src="./images/carousel/4g-logo.jpg" height="100" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
